import React, { ChangeEvent, memo } from 'react';
import classNames from 'classnames';
import cls from './Input.module.css';
import { newSumFormFormatter } from '../../../shared/helpers/sumFormFormatter';

interface InputProps {
    label?: string;
    inputName: string;
    onChange: (name: string, value: string) => void;
    onError?: (value: string) => void;
    error?: string | null;
    value: string;
    placeholder?: string;
    classes?: string;
    type?: string;
    required?: boolean;
    errorMessage?: string;
    isDisabled?: boolean;
    isMoney?: boolean;
    maxLength?: number;
    onEnterPress?: () => void;
    icon?: React.ReactNode;
    message?: string;
    onBlurHandler?: () => void;
    onFocusHandler?: () => void;
}

export const Input = memo(
    ({
        label,
        inputName,
        onChange,
        onError = () => {},
        error = '',
        value,
        placeholder,
        classes,
        type = 'text',
        required = false,
        errorMessage = '',
        isDisabled = false,
        isMoney = false,
        maxLength,
        onEnterPress,
        icon,
        message,
        onFocusHandler,
        onBlurHandler,
    }: InputProps) => {
        const onInput = (event: ChangeEvent<HTMLInputElement>) => {
            let { name, value } = event.target;
            if (type === 'number' || type === 'measurements') {
                value = newSumFormFormatter(value, isMoney);
            }
            onChange(name, value);
        };

        const onBlur = (event: ChangeEvent<HTMLInputElement>) => {
            if (!!onBlurHandler) {
                onBlurHandler();
                return;
            }
            let { value } = event.target;
            if (required && !value) {
                onError(errorMessage);
            } else {
                onError('');
            }
        };

        const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
            if (event.key === 'Enter' && onEnterPress) {
                onEnterPress();
            }
        };
        return (
            <>
                <label className={classNames(cls.label, [classes])}>
                    <span className={classNames(cls.labelSpan, required ? cls.required : '')}>
                        {label}
                    </span>
                    <div
                        className={classNames(cls.inputContainer, {
                            [cls.disabled]: isDisabled,
                        })}
                    >
                        <input
                            maxLength={maxLength ? maxLength : null}
                            disabled={isDisabled}
                            onBlur={onBlur}
                            onInput={onInput}
                            className={classNames(cls.Input, {
                                [cls.error]: !!error,
                                [cls.inputWithIcon]: !!icon,
                            })}
                            name={inputName}
                            value={value}
                            placeholder={placeholder}
                            onKeyDown={onKeyDown}
                            type={type}
                            onFocus={onFocusHandler}
                        />
                        {icon && <div className={cls.inputIcon}>{icon}</div>}
                    </div>
                    {!!message && <div className={cls.messageBlock}>{message}</div>}
                    {!!error && <div className={cls.errorBlock}>{error}</div>}
                </label>
            </>
        );
    }
);
